/**
 * Ficmoon 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Ficmoon 品牌特定主题配置
 */
export const theme = {
  // 头像边框色 (Ficmoon 使用 #FFFFFF20)
  avatarBorder: '#FFFFFF20',
  // 按钮背景色 (Ficmoon 使用 #F3EEFF)
  btnPrimaryBg: '#F3EEFF',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/ficmoon/member_subscribe_bg.webp)',
  // 订阅文本
  subscribeText: '#7D380B',
  // 订阅文本2
  subscribeText2: '#AC6D1F',
  // 订阅背景
  subscribeBg: '#90491B',
} as const

/**
 * Ficmoon 品牌特定资源配置
 */
export const resources = {
  // 用户背景图
  userBg: '/images/ficmoon/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/ficmoon/user-default.png',
  // VIP 图标
  memberVip: '/images/ficmoon/vip_icon2.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/ficmoon/vip_discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
